import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import { processor } from '../../utils/seafile-markdown2html';
import '../../assets/css/comment-dialog.css';
var CommentDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(CommentDialog, _React$Component);
  var _super = _createSuper(CommentDialog);
  function CommentDialog(props) {
    var _this;
    _classCallCheck(this, CommentDialog);
    _this = _super.call(this, props);
    _this.handleCommentChange = function (event) {
      var comment = event.target.value;
      _this.setState({
        comment: comment
      });
    };
    _this.submitComment = function () {
      var comment = _this.state.comment.trim();
      if (comment.length > 0 && _this.props.quote.length > 0) {
        var detail = {
          quote: _this.props.quote,
          position: _this.props.commentPosition
        };
        var detailJSON = JSON.stringify(detail);
        _this.props.editorApi.postComment(comment, detailJSON).then(function (res) {
          _this.props.onCommentAdded();
        });
      }
    };
    _this.setQuoteText = function (mdQuote) {
      processor.process(mdQuote).then(function (result) {
        var quote = String(result);
        _this.setState({
          quote: quote
        });
      });
    };
    _this.state = {
      comment: '',
      quote: ''
    };
    return _this;
  }
  _createClass(CommentDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setQuoteText(this.props.quote);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.quote !== nextProps.quote) {
        this.setQuoteText(nextProps.quote);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$state = this.state,
        comment = _this$state.comment,
        quote = _this$state.quote;
      return /*#__PURE__*/React.createElement("div", {
        className: "seafile-editor-comment comment-dialog"
      }, /*#__PURE__*/React.createElement("div", null, this.props.editorApi.name), /*#__PURE__*/React.createElement("blockquote", {
        className: "comment-dialog-quote"
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: quote
        }
      })), /*#__PURE__*/React.createElement("textarea", {
        value: comment,
        onChange: this.handleCommentChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "primary",
        onClick: this.submitComment
      }, t('submit')), /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "secondary",
        onClick: this.props.toggleCommentDialog
      }, t('cancel'))), /*#__PURE__*/React.createElement("span", {
        className: "comment-dialog-triangle"
      }));
    }
  }]);
  return CommentDialog;
}(React.Component);
export default withTranslation('seafile-editor')(CommentDialog);